import { render, staticRenderFns } from "./CardResultado.vue?vue&type=template&id=a1db0cf0&scoped=true"
import script from "./CardResultado.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardResultado.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardResultado.vue?vue&type=style&index=0&id=a1db0cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1db0cf0",
  null
  
)

export default component.exports